// Widening type to `string` to side-step Compiled cssMap typescript warnings with unknown properties
export const chevronDisplayCssVar: string = '--expandable-chevron-display';
export const providedElemBeforeDisplayCssVar: string = '--expandable-provided-elembefore-display';

export const expandableMenuItemIndentation = '12px';

/**
 * A symbol to collapse the `elemBefore` slot.
 * This should be placed in the `elemBefore` prop of supported menu items.
 */
export const COLLAPSE_ELEM_BEFORE: unique symbol = Symbol('collapse-elem-before');
export type COLLAPSE_ELEM_BEFORE_TYPE = typeof COLLAPSE_ELEM_BEFORE;

// must render above mini-modal
export const Z_INDEX_SIDENAV = 810;

// must render above the sidenav
export const Z_INDEX_POPUP_COMPONENTS = 820;

export const TESTID_PREFIX = 'rovo-navigation';

// Time calculation constants
const HOURS_IN_DAY = 24;
const MINUTES_IN_HOUR = 60;
const SECONDS_IN_MINUTE = 60;
const MILLISECONDS_IN_SECOND = 1000;
export const MILLISECONDS_IN_DAY: number =
	HOURS_IN_DAY * MINUTES_IN_HOUR * SECONDS_IN_MINUTE * MILLISECONDS_IN_SECOND;

// Time period constants for conversation grouping
export const DAYS_FOR_YESTERDAY = 1;
export const DAYS_FOR_WEEK = 7;
export const DAYS_FOR_TWO_WEEKS = 14;
export const DAYS_FOR_MONTH = 30;

// Group index export constants for conversation categorization
export const TODAY_GROUP_INDEX = 0;
export const YESTERDAY_GROUP_INDEX = 1;
export const WEEK_GROUP_INDEX = 2;
export const MONTH_GROUP_INDEX = 3;
export const FURTHER_BACK_INDEX = 4;
